import React from 'react';

import EventStatus from '@swf/sports/components/EventStatus/EventStatus';
import type { EventStatus as EventStatusType } from '@swf/sports/components/EventStatus/hooks/useEventStatus';
import QuickSwitcher from '@swf/sports/components/QuickSwitcher/QuickSwitcher';
import type { EventTypeId } from '@swf/sports/types/eventType';

import styles from './DefaultEventCard.scss';

export interface Props {
  eventTime: string;
  inPlay?: boolean;
  title: string;
  eventStatusOverride?: EventStatusType;
  canTurnInPlay?: boolean;
  subTitle?: string;
  titleOnly?: boolean;
  eventTypeId: EventTypeId;
}

const DefaultEventCard: React.FC<Props> = ({
  title,
  eventTime,
  inPlay,
  eventStatusOverride,
  canTurnInPlay,
  subTitle,
  titleOnly,
  eventTypeId
}) => (
  <div className={styles.wrapper} data-testid="default-event-card">
    <QuickSwitcher title={title} />
    {!titleOnly ? (
      <>
        {subTitle ? <h2 className={styles.cardSubtitle}>{subTitle}</h2> : null}
        <div className={styles.status}>
          <EventStatus
            eventTypeId={eventTypeId}
            eventStatusOverride={eventStatusOverride}
            canTurnInPlay={canTurnInPlay}
            inPlay={inPlay}
            startTime={eventTime}
            timeFormat="long"
            size="Small"
          />
        </div>
      </>
    ) : null}
  </div>
);

export default DefaultEventCard;
